import { useTranslation } from "react-i18next";

/* Fase D — rótulo gráfico de intro sobre el reproductor de vídeo del caballo.
   Overlay HTML/CSS puro: el archivo de vídeo NUNCA se modifica ni re-renderiza.
   Renderiza SIEMPRE desde la ficha en vivo (cero snapshots): si se corrige el
   nombre/pedigree, el rótulo cambia solo. Los nombres propios no se traducen. */
export const HorseVideoIntro = ({ horse, logoUrl, style = "dark", fading, onTap }) => {
  const { t } = useTranslation();
  if (!horse?.name) return null;

  const sire = horse.pedigree?.sire?.name;
  const dam = horse.pedigree?.dam?.name;
  const damSire = horse.pedigree?.dam?.sire?.name;
  const meta = [horse.year_of_birth, horse.studbook].filter(Boolean).join(" · ");
  const dark = style !== "light";

  const pedigreeParts = [
    sire && { label: t("horse.sire"), name: sire },
    dam && { label: t("horse.dam"), name: dam },
    damSire && { label: t("horse.damSire"), name: damSire, hideOnMobile: true },
  ].filter(Boolean);

  return (
    <div
      data-testid="horse-video-intro"
      aria-hidden={fading ? "true" : undefined}
      onClick={onTap}
      className={`absolute inset-0 z-10 flex flex-col justify-end transition-opacity duration-[2500ms] ease-[cubic-bezier(0.22,1,0.36,1)] ${
        fading ? "opacity-0" : "opacity-100"
      } ${onTap ? "cursor-pointer" : "pointer-events-none"}`}
      style={{
        background: dark
          ? "linear-gradient(to top, rgba(10,10,10,0.90) 0%, rgba(10,10,10,0.45) 45%, rgba(10,10,10,0.12) 75%, rgba(10,10,10,0.05) 100%)"
          : "linear-gradient(to top, rgba(255,255,255,0.94) 0%, rgba(255,255,255,0.62) 45%, rgba(255,255,255,0.14) 75%, rgba(255,255,255,0.04) 100%)",
      }}
    >
      {logoUrl && (
        <span className="absolute top-4 right-4 sm:top-5 sm:right-5">
          <img
            src={logoUrl}
            alt=""
            data-testid="video-intro-logo"
            className={`h-7 sm:h-9 w-auto max-w-[140px] object-contain ${dark ? "drop-shadow-[0_1px_6px_rgba(0,0,0,0.45)]" : ""}`}
          />
        </span>
      )}
      <div className={`flex flex-col gap-1 sm:gap-1.5 p-5 pb-12 sm:p-8 sm:pb-14 ${dark ? "text-white" : "text-[#0A0A0A]"}`}>
        {meta && (
          <span
            data-testid="video-intro-meta"
            className={`text-[11px] sm:text-xs font-semibold uppercase tracking-[0.22em] ${dark ? "text-white/70" : "text-[#0A0A0A]/55"}`}
          >
            {meta}
          </span>
        )}
        <h3
          data-testid="video-intro-name"
          className="text-xl sm:text-3xl lg:text-4xl font-semibold tracking-tight uppercase leading-tight"
        >
          {horse.name}
        </h3>
        {pedigreeParts.length > 0 && (
          <p data-testid="video-intro-pedigree" className="text-xs sm:text-sm leading-relaxed">
            {pedigreeParts.map((p, i) => (
              <span key={p.label} className={p.hideOnMobile ? "hidden sm:inline" : undefined}>
                {i > 0 && <span className={`mx-1.5 ${p.hideOnMobile ? "hidden sm:inline" : ""}`} aria-hidden="true">·</span>}
                <span className={dark ? "text-white/60" : "text-[#0A0A0A]/50"}>{p.label}: </span>
                <span className="font-medium">{p.name}</span>
              </span>
            ))}
          </p>
        )}
      </div>
    </div>
  );
};
